<template>
	<div class="pages">
		<sub-ibox-title><p slot="title">{{params.id ? '编辑关键词': '新增关键词'}}</p></sub-ibox-title>
		<section class="content">
			<div class="fx fx-y-center w400">
				<p class="w60">关键词：</p>
				<p class="fx-fill">
					<input maxlength="20" v-on:blur = "handleInputKeyWords" @keyup.enter="handleInputKeyWords" v-model.trim="keyWords" class="input" type="text" placeholder="请输入关键词,关键词输入完成敲击回车" />
				</p>
			</div>
			<div class="keywords-content">
				<div class="key-list m-t-5">
					<ol class="fx fx-wrap">
						<li v-for="(item,index) in keyWordsArr">
							{{item}}
							<em class="icon-del" @click="handleDelInputKeyWords(index)"></em>
						</li>
					</ol>
				</div>
				<section class="m-t-15">
					<z-radio-material 
						:radio-bar-params ="radioBarParams" 
						:is-layer-material ="isLayerMaterial"
						@cancelMaterialLayer = "cancelMaterialLayer"
						@handleClickRadioBar ="handleClickRadioBar"
						@handleSetContent = "handleSetContent"
						>
					</z-radio-material>
				</section>
		  		
		  		<div class="m-t-20">
		  			<a class="z-btn z-btn-primary b-r-3" @click="handleSubmit">保存</a>
		  		</div>
			</div>
	  	</section>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	export default {
		name: 'WxKeyWordsEdit',
		data() {
			return {
				radioBarParams: {
					list: [{
						title: '文字',
						type: 'text',
						content:''
					}, {
						title: '图文',
						type: 'news',
						content:''
					}, {
						title: '图片',
						type: 'image',
						content:''
					}, {
						title: '语音',
						type: 'voice',
						content:''
					}, {
						title: '视频',
						type: 'video',
						content:''
					}],
					active: 'text' //默认
				},
				isLayerMaterial :false,//是否显示素材弹出层
				keyWords:null,//双向绑定关键词
				keyWordsArr:[],
				params:{
					id:null,
					radioType:'text',//回复类型
					content:null,//回复的JSON对象
					keywords:null //关键词
				}
			}
		},
		mounted() {
			this.params.id = this.$route.query.id || null
			if(this.params.id) this.handleGetEditItem()
			
		},
		/*
		 * 属性计算
		 */
		computed: {
		},
		/*
		 * 事件处理
		 */
		methods: {
			cancelMaterialLayer(){//显示隐藏弹出层
				this.isLayerMaterial = this.isLayerMaterial ? false : true
			},
			handleClickTabBar(type){//切换tabbar
				this.tabBarParams.active = type
			},
			handleClickRadioBar(type){//切换radioBar
				this.radioBarParams.active = type
			},
			handleSetContent(content=null,type =null){
				let index = this.getKey()
				this.radioBarParams.list[index].content = content
			},
			handleInputKeyWords(){//处理输入的关键词
				if(!this.keyWords){
					return
				}
				if(this.keyWordsArr.length>=5){
					this.$warning('最多添加5个关键词喔/(ㄒoㄒ)/~~')
					return
				}
				this.keyWordsArr.push(this.keyWords)
				this.keyWords = null
			},
			handleDelInputKeyWords(index){//删除输入的关键词
				this.keyWordsArr.splice(index,1)
			},
			handleGetEditItem(){//获取需要编辑的item
				let item = this.$getSessionStorage('KEY_WORDS_ITEM',null)
				this.$log(item)
				this.radioBarParams.active = item.reply_type
				this.keyWordsArr = item.keywords.split('|')
				
				let index = this.getKey()
				
				this.radioBarParams.list[index].content = item.content
			},
			setParamsContent(){//设置保存的回复内容
				let index = this.getKey()
				this.params.content = this.radioBarParams.list[index].content
				this.params.keywords = this.keyWordsArr.join("|")
				this.params.radioType = this.radioBarParams.active
			},
			getKey(){
				switch (this.radioBarParams.active){
					case 'text': return 0
					case 'news': return 1
					case 'image':return 2
					case 'voice':return 3
					case 'video':return 4
					default: return null
				}
			},
			async handleSubmit(){//保存关键词
				this.setParamsContent()
				
				if(!this.params.keywords || !this.params.content){
					this.$warning('请填写关键词或者回复内容喔/(ㄒoㄒ)/~~')
					return
				}
				try{
					await this.saveKeywords(this.params)
					this.$success('保存成功')
					this.$back()
				}catch(e){
					this.$error(e)
					this.$errorMsg('保存失败')
				}
				
				
			},
			...mapActions(['saveKeywords']),
		}
	}
</script>
<style scoped lang="scss">
@import "src/assets/css/common.scss";
	.w60{
		width: 60px;
	}
	.keywords-content{
		padding-left: 60px;
	}
	.sub-ibox-title{
		border-bottom: none;
	}
	.key-list{
		/*padding-left: px-em(120px);*/
		li{
			margin-right: px-em(20px);
			margin-top:10px;
			background:$color-e5e7ec;
			padding: 3px 10px;
			position: relative;
			em{
					position: absolute;
					width: 20px;
					height: 20px;
					right: -10px;
					top: -10px;
					color:$color-main;
					font-size: 20px;
					z-index: 2;
					display: none;
					cursor: pointer;
				}
			&:hover{
				em{
					display: block;
				}
			}
			
		}
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.tab-bar,.content,.sub-ibox-title {
			min-width: px-em(900px);
		}	
	}
</style>


// WEBPACK FOOTER //
// WxKeyWordsEdit.vue?29808a24